<template>
  <el-table
    :data="stockTakings"
    style="width: 100%"
    stripe
    highlight-current-row
    :row-class-name="'pointer-row'"
    @row-click="(row) => $router.replace('/processes/stock-takings/stock-takings/view/' + row.id)"
  >
    <el-table-column
      show-overflow-tooltip
      prop="receipt_number"
      label="Bizonylatszám"
      width="180"
    />
    <el-table-column
      prop="storage_name"
      label="Raktár"
      width="180"
    />
    <el-table-column
      prop="completed_at"
      label="Teljesítés dátuma"
    />
    <el-table-column
      prop="creator_user_name"
      label="Rögzítette"
    />
    <el-table-column
      prop="created_at"
      label="Rögzítve"
    >
      <template slot-scope="scope">
        {{ scope.row.created_at | dateTime }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "StockTakingList",
  props: ['stockTakings'],
}
</script>
